import { useEffect, useState } from 'react';
import { Formik, Field, ErrorMessage, Form } from 'formik';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { useRouter } from 'next/router';
import CONTACT_REQUEST, {
  CONTACT_REQUEST_INTERFACE
} from '../../api/contactRequest';
const ContactMsg = () => {
  const router = useRouter();
  const isRelationsPage = router.asPath.includes('/public-relations');
  const [contactInfo, setContactInfo] = useState<Record<string, any>>({
    name: '',
    email: '',
    message: ''
  });
  const [addQuery, { data: addedQuery, loading, error }] =
    useMutation<CONTACT_REQUEST_INTERFACE>(CONTACT_REQUEST);
  useEffect(() => {
    if (addedQuery) {
      toast.success('We recieved your request we will get to you shortly');
    }
  }, [addedQuery]);
  const handleSubmit = async (values: Record<string, any>) => {
    await addQuery({
      variables: {
        name: values.name,
        email: values.email,
        message: values.message
      }
    });
  };
  return (
    <section
      id="contact-msg"
      className={`py-3 sm:py-5 ${isRelationsPage ? 'py-0' : ''} `}
    >
      <div
        className={`w-[90%] md:w-[55%] mx-auto ${
          isRelationsPage ? 'md:w-[85%]' : ''
        } `}
      >
        <div className="text-center">
          {isRelationsPage ? (
            // If the URL contains "relations", display this
            <h1 className="text-3xl font-bold text-[#333333] text-left md:text-[22px] xl:text-[32px]">
              Contact Us
            </h1>
          ) : (
            // Default content if "relations" is not in the URL
            <>
              <h2 className="text-[18px] lg:text-4xl font-bold lg:font-semibold text-[#333333]">
                Send Us A Message
              </h2>
              <h4 className="text-[14px] lg:text-[28px] font-normal lg:font-semibold text-[#333333]">
                We&apos;d love to hear from you
              </h4>
            </>
          )}
        </div>

        <Formik
          initialValues={contactInfo}
          validate={values => {
            const errors: any = {};
            if (
              !/^[a-zA-Z-\s]{0,30}$/.test(values.name) ||
              values.name === ''
            ) {
              errors.name = 'Enter Valid Name';
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = 'Invalid email address';
            } else if (values.message.length < 8) {
              errors.message = 'Enter Atleast 8 Characters';
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            await handleSubmit(values);
            resetForm();
            setSubmitting(false);
          }}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <label
                htmlFor="name"
                className={`block text-[16px] sm:text-[20px] text-black mt-3 ${
                  isRelationsPage ? 'md:text-[14px] xl:text-[18px]' : ''
                } `}
              >
                Name
              </label>
              <Field
                id="name"
                name="name"
                className={`w-full text-[12px] sm:text-[16px] placeholder:text-[#8F8F8F] focus:outline-none bg-[#EEEEEE] p-5 rounded-md lg:rounded-xl mt-2 ${
                  isRelationsPage
                    ? 'md:text-[12px] md:p-2 xl:text-[18px] xl:p-4 bg-white'
                    : ''
                } `}
                placeholder="Name"
                type="text"
                required
              />
              <ErrorMessage
                name="name"
                component="div"
                className={`text-red-400 ${
                  isRelationsPage ? 'md:text-[14px] xl:text-[18px]' : ''
                } `}
              />
              <label
                htmlFor="email"
                className={`block text-[16px] sm:text-[20px] text-black mt-3 ${
                  isRelationsPage ? 'md:text-[14px] xl:text-[18px]' : ''
                } `}
              >
                Email
              </label>
              <Field
                id="email"
                name="email"
                className={`w-full text-[12px] sm:text-[16px] placeholder:text-[#8F8F8F] focus:outline-none bg-[#EEEEEE] p-5 rounded-md lg:rounded-xl mt-2 ${
                  isRelationsPage
                    ? 'md:text-[12px] md:p-2 xl:text-[18px] xl:p-4 bg-white'
                    : ''
                } `}
                placeholder="Name@gmail.com"
                type="email"
                required
              />
              <ErrorMessage
                name="email"
                component="div"
                className={`text-red-400 ${
                  isRelationsPage ? 'md:text-[14px] xl:text-[18px]' : ''
                } `}
              />
              <label
                htmlFor="message"
                className={`block text-[16px] sm:text-[20px] black mt-3 ${
                  isRelationsPage ? 'md:text-[14px] xl:text-[18px]' : ''
                } `}
              >
                Message
              </label>
              <Field
                id="message"
                name="message"
                as="textarea"
                className={`w-full text-[12px] sm:text-[16px] placeholder:text-[#8F8F8F] focus:outline-none bg-[#EEEEEE] p-5 rounded-md lg:rounded-xl h-[150px] lg:h-[200px] mt-2 ${
                  isRelationsPage
                    ? 'md:text-[12px] md:p-2 md:h-[80px] xl:text-[18px] xl:p-4 xl:h-[200px] bg-white'
                    : ''
                } `}
                placeholder="Type your query here....."
              />
              <ErrorMessage
                name="message"
                component="div"
                className={`text-red-400 ${
                  isRelationsPage ? 'md:text-[14px] xl:text-[18px]' : ''
                } `}
              />
              <div
                className={`font-bold mt-5 ml-auto float-right ${
                  isRelationsPage ? 'md:mt-2' : ''
                } `}
              >
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`rounded-md text-xs lg:text-base py-2 px-5 sm:px-10 bg-primary text-white ${
                    isRelationsPage
                      ? 'xl:text-[20px] py-3 xl:py-4 xl:px-10 md:py-3 md:px-8'
                      : ''
                  } `}
                >
                  {isRelationsPage ? 'Get In Touch' : 'Submit'}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default ContactMsg;
